/** The filename from a Content-Disposition header, if it names one. */
export function filenameFromDisposition(
  header: string | null | undefined,
): string | null {
  if (!header) return null;
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch {
      // fall through to the plain form
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain ? plain[1].trim() : null;
}

/** Saves a downloaded blob through a temporary link. */
export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

/**
 * Saves an axios `responseType: 'blob'` response, named by its
 * Content-Disposition header or `fallbackName`.
 */
export function saveBlobResponse(
  response: { data: Blob; headers: Record<string, any> },
  fallbackName: string,
) {
  const name =
    filenameFromDisposition(response.headers?.['content-disposition']) ||
    fallbackName;
  saveBlob(response.data, name);
}
